import { Component, HostListener, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SearchmaskComponent } from 'searchmask-lib';
import { AvailabilityService, ExternalLoginService, IAvailabilityData, ICartItem, IExternalLoginData, PIMHotelInfov2, PIMService, StorageService } from 'core-lib';
import { AvailabilityRoom1Component } from '../../components/availability-room-1/availability-room-1.component';
import { ButtonModule } from 'primeng/button';
import { SettingsService } from 'core-lib';
import { ISearchParams, IShopCart, ISmCategory } from 'core-lib';
import { MultiroomNavigatorComponent } from '../../components/multiroom-navigator/multiroom-navigator.component';
import { Subscription } from 'rxjs';
import { AsyncPipe, JsonPipe, ViewportScroller } from '@angular/common';
import { ShopcartService } from 'core-lib';
import { animate, style, transition, trigger } from '@angular/animations';
import { AvailabilityRoom1SkeletonComponent } from '../../components/availability-room-1-skeleton/availability-room-1-skeleton.component';
import { LanguageService } from 'core-lib';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvailabilityRoom2Component } from '../../components/availability-room-2/availability-room-2.component';
import { AvailabilityRoom2SkeletonComponent } from '../../components/availability-room-2-skeleton/availability-room-2-skeleton.component';
import { MoreRatesPopupComponent } from "../../components/more-rates-popup/more-rates-popup.component";
import { AvailabilityRoomReadmoreComponent } from '../../components/availability-room-readmore/availability-room-readmore.component';
import { MessageModule } from 'primeng/message';
import { HotelDetailsPopupComponent } from '../../components/hotel-details-popup/hotel-details-popup.component';
import { PIMContactDetailsv2, PimNotificationComponent } from 'core-lib';
import { ExternalLoginPopupComponent } from "../../components/external-login-popup/external-login-popup.component";
import { AlternativeAvailabilityComponent } from '../../components/alternative-availability/alternative-availability.component';
import { Router } from '@angular/router';
import { extractLinkOnly, ILinkOnly } from '../../utils/extract-link-only';

@Component({
    selector: 'app-availability',
    imports: [
        SearchmaskComponent,
        AvailabilityRoom1Component,
        AvailabilityRoom2Component,
        MultiroomNavigatorComponent,
        ButtonModule,
        AvailabilityRoom1SkeletonComponent,
        AvailabilityRoom2SkeletonComponent,
        TranslateModule,
        MoreRatesPopupComponent,
        AvailabilityRoomReadmoreComponent,
        MessageModule,
        HotelDetailsPopupComponent,
        PimNotificationComponent,
        ExternalLoginPopupComponent,
        AlternativeAvailabilityComponent
    ],
    templateUrl: './availability.component.html',
    styleUrl: './availability.component.scss',
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [style({ opacity: 0 }), animate('400ms', style({ opacity: 1 }))]),
            transition(':leave', [animate('400ms', style({ opacity: 0 }))]),
        ]),
    ]
})
export class AvailabilityComponent implements OnInit, OnDestroy{

  @ViewChild(MultiroomNavigatorComponent, { static: false })
  private multiroomNavigatorComponent: MultiroomNavigatorComponent;


  av: any;
  originalAv:any;
  allotments: any;
  activeCategory:ISmCategory;
  showSearchMask:boolean = false;
  changeDetected:boolean = false;
  searchParams:ISearchParams|null;
  roomCount:number;
  activeAvIndex:number = 0 ;
  language: string;
  availableCategories:any = [];
  categoriesInSettings:ISmCategory[] = [];
  noAvInSomeIndex:any = null;
  noRatesWithBookingCode:null|string= null;
  codeFoundInAllotment:any = null;
  moreRatesPopupContent:any = null;
  readmoreContent:any = null;
  cardCountPerRowArray:any[] = [];
  hotelDetailsOpened:boolean = false;
  // Browser back button closes the open dialog instead of navigating away.
  // Opening a dialog pushes a dummy same-URL history entry. Back button fires
  // popstate → dialog closes. Closing via UI marks the entry stale; the next
  // popstate with no dialog open calls history.go(-1) to skip to the real
  // previous page (a different URL), avoiding Angular's onSameUrlNavigation reload.
  private dialogOpenedViaHistory: boolean = false;
  private staleDialogEntry: boolean = false;
  hotelData:PIMHotelInfov2|null;
  hotelDetailsLink: ILinkOnly | null = null;
  contactDetails:PIMContactDetailsv2|null
  sameDayError:boolean = false;
  bookingCutoffError:boolean = false;
  allRoomsEmpty:boolean = false;
  gotoExternalLoginConfrmationVisible:boolean = false;
  externalLoginData: IExternalLoginData|null = null;
  showLoginData: boolean = true;
  hasMembershipTiers:boolean = false;
  private subs: Subscription[] = []


  constructor (
    private avService: AvailabilityService, 
    private shopCartService: ShopcartService, 
    public settings: SettingsService, 
    private languageService: LanguageService,
    private viewportScroller: ViewportScroller,
    private pimService: PIMService,
    private translate: TranslateService,
    private externalLoginService: ExternalLoginService,
    private storage: StorageService,
    private router: Router
  ) {
    if (this.avService.getSearchParams()) {
      this.searchParams = this.avService.getSearchParams();
    }
    if (this.searchParams) {
      this.roomCount = this.searchParams.roomData?.length || 0;
    }
  }
  

  ngOnInit(): void {

    this.language = this.languageService.getCurrentLanguage();

    this.categoriesInSettings = this.settings.getCategories(this.language) ?? [];
    let hasAll = this.categoriesInSettings?.find((item:ISmCategory) => {return item.value == 'ALL'});
    // add all category in the beginning
    if ((this.categoriesInSettings && this.categoriesInSettings.length > 0) && !hasAll) {
      this.categoriesInSettings.unshift({value: 'ALL', name: this.translate.instant('sm.categoryAll')})
    }

    this.cardCountPerRowArray = new Array(this.settings.get('availability.cardCountPerRow'));

    this.loadExternalLoginData();

    // get categories from settings and and set category from search params.
    if (this.categoriesInSettings?.length > 0) {
      if (this.searchParams?.category) {

        let cats = this.categoriesInSettings;
        
        let activeCat = cats.find((item:ISmCategory) => item.value == this.searchParams?.category);
        if (activeCat) {
          this.changeCategory(activeCat);
        }
      }
      else {
        this.changeCategory(this.categoriesInSettings[0]);
      }
    }
    else {
      this.activeCategory = {value: 'ALL', name: this.translate.instant('sm.categoryAll')};
    }

    this.shopCartService.clearShopCart();
    //subscribe to the availability object

    this.subs.push(
      this.avService.availability$.subscribe((data) => {
        //setTimeout(() => {this.av = data}, 20000);  // for skeleton testing
        if (data?.[0]=='SAMEDAY_LIMIT_EXCEEDED') {
          this.sameDayError = true;
          this.av=[];
          this.originalAv = []; 
        }
        else if (data?.[0]=='BOOKING_CUTOFF_LIMIT_EXCEEDED') {
          this.bookingCutoffError = true;
          this.av=[];
          this.originalAv = []; 
        }
        else {
          this.originalAv = JSON.parse(JSON.stringify(data)); // deep copy of original availability
          this.av = JSON.parse(JSON.stringify(data));

        }

        this.noAvInSomeIndex = null; // reset no av, so it does not falsely show up after new search
        this.noRatesWithBookingCode = null;
        this.codeFoundInAllotment = null;
        this.allRoomsEmpty = false;

        if (this.av) {

          this.checkRateTiers();

          if (this.av.length == 0) {
            this.noAvInSomeIndex={
              roomIndex: 0,
              searchParams: this.searchParams?.roomData[0]
            }
          }
          else {
            this.av.forEach((roomAv:any, index:number) => {
              this.availableCategories.push([]);
              if (roomAv.length == 0) {
                
                let sp = this.searchParams?.roomData[index];
              
                this.noAvInSomeIndex={
                  roomIndex: index,
                  searchParams: sp
                }
              }
              else {
                roomAv.forEach((room:any) => {

                  if (this.settings.get('searchMask.usePmsCategories')) {
                    if (!this.availableCategories[index].includes(room?.roomrates[0].room.roomCategory)) {
                      this.availableCategories[index].push(room?.roomrates[0].room.roomCategory);
                    }
                  }
                  else {
                    if (!this.availableCategories[index].includes(room?.roomrates[0].room.beRoomCategoryCode)) {
                      this.availableCategories[index].push(room?.roomrates[0].room.beRoomCategoryCode);
                    }
                  }
                });
                
                
              }

              if (this.searchParams?.bookingCode) {
                let ratesWithBookingCode = roomAv.find((room:any) => room.bookingCode);
                this.codeFoundInAllotment = this.allotments?.find((allotment:any) => allotment.code.toLowerCase() == this.searchParams?.bookingCode.toLowerCase());
                if (!ratesWithBookingCode && !this.codeFoundInAllotment) {
                  this.noRatesWithBookingCode = this.searchParams?.bookingCode;
                }


              }
            
            });
          }
        }

        this.allRoomsEmpty = !this.sameDayError && !this.bookingCutoffError && Array.isArray(this.av) && this.av.length > 0 && this.av.every((roomAv: any) => roomAv.length === 0);

      })
    );

    this.avService.allotments$.subscribe((data) => {
      this.allotments = data;
    });
    
    this.av = null;
    if (this.searchParams) {
      this.avService.fetchAvailability();
    }
    else {
      console.warn("No search params, navigating back to home");
      this.router.navigate(['/']);
    }

    if (this.searchParams?.hotelCode) {
      this.hotelData = this.pimService.getHotelInfo(this.searchParams?.hotelCode);
      this.hotelDetailsLink = extractLinkOnly((this.hotelData as any)?.longDescription ?? (this.hotelData as any)?.description);
      this.contactDetails = this.pimService.getContactDetails(this.searchParams?.hotelCode);
    }
  }

  checkRateTiers() {
    this.hasMembershipTiers = false;
    this.av.forEach((roomAv:any) => {
      roomAv.forEach((room:any) => {
        room.roomrates.forEach((roomrate:any) => {
          if (roomrate.rate.membershipTier && roomrate.rate.membershipTier.length > 0) {
            this.hasMembershipTiers = true;
          }
        });
      });
    });
  }

  changeCategory(value:ISmCategory) {
    this.activeCategory = value;
  }

  setChangeDetected(value:boolean) {
    this.changeDetected = value;
  }

  handleRoomSelected(roomrate:IAvailabilityData) {

    let useExternalLogin = this.settings.get('externalLoginProvider')?.length > 0;
    let hasMembershipTier = roomrate.rate.membershipTier && roomrate.rate.membershipTier.length > 0;
    
    
    if (useExternalLogin && hasMembershipTier && !this.externalLoginData) {
      // Has to login to book this room
      this.gotoExternalLoginConfrmationVisible = true;
    }
    else {
      this.avService.selectRoomRate(roomrate, this.activeAvIndex);
      this.handleCloseMoreRates();

      if (this.roomCount > 1) {
        this.checkAvailableRoomCount()
        this.multiroomNavigatorComponent.navigatorClosed = false;
        this.multiroomNavigatorComponent.roomSelected(this.activeAvIndex);
        this.incrementActiveAvIndex();

        this.viewportScroller.scrollToAnchor('multiRoomScrollAnchor')
      }
    }
  }

  proceedToExternalLogin() {
    this.externalLoginService.loginToProvider(this.settings.get('externalLoginProvider'));
  }

  checkAvailableRoomCount() {

    let cartItems = this.shopCartService.getCart()?.getCartItemsByType("roomrate");
    let avDeepCopy = JSON.parse(JSON.stringify(this.originalAv)); // deep copy of original availability


    //loop cartitems and reduce the realTimeAvailableRooms count from availability
    cartItems?.forEach((ci:ICartItem, cartItemIndex:number) => {
      let roomCode = ci?.item.room.roomCode;

      //loop original availability and find the roomcode and reduce the realTimeAvailableRooms count
      avDeepCopy.forEach((roomAv:any, index:number) => {
        let foundRoom = roomAv.find((room:any) => room.roomCode == roomCode);
        if (foundRoom) {

          foundRoom.realTimeAvailableRooms = foundRoom.realTimeAvailableRooms - 1;

          if (foundRoom.realTimeAvailableRooms < 1) {
            // if real time available rooms goes below 0, remove the room from availability if the index is not the selected room index
            // because the user can select the same room for the same index
            // except if the roomcode in the cartItems with the same index is the same, then it should not be removed
            
            if (index != cartItemIndex) {
              avDeepCopy[index] = roomAv.filter((room:any) => room.roomCode != roomCode);
            }
          }
        }
      });
    });
    
    this.av = JSON.parse(JSON.stringify(avDeepCopy));
  }

  handleOpenMoreRates(roomData:any) {
    this.moreRatesPopupContent = roomData;
    this.pushDialogHistory();
  }
  handleCloseMoreRates() {
    this.cleanupDialogHistory();
    this.moreRatesPopupContent = null;
  }

  handleOpenReadmore(roomData:any) {
    const linkOnly: ILinkOnly | null = extractLinkOnly(roomData?.roomrates?.[0]?.room?.pim?.longDescription);
    if (linkOnly) {
      window.open(linkOnly.url, '_blank', 'noopener,noreferrer');
      return;
    }
    this.readmoreContent = roomData;
    this.pushDialogHistory();
  }
  handleCloseReadmore() {
    this.cleanupDialogHistory();
    this.readmoreContent = null;
  }

  incrementActiveAvIndex() {
    let cart:IShopCart|null = this.shopCartService.getCart();
    if (cart) {
      if (this.activeAvIndex < this.roomCount - 1) {
        this.activeAvIndex = cart.items.length;      
      }
    }
    
  }

  handleRoomIndexChange(event:number) {
    this.activeAvIndex = event;
  }

  openHotelDetails() {
    if (this.hotelDetailsLink) {
      window.open(this.hotelDetailsLink.url, '_blank', 'noopener,noreferrer');
      return;
    }
    this.hotelDetailsOpened = true;
    this.pushDialogHistory();
  }
  handleCloseHotelDetails() {
    this.cleanupDialogHistory();
    this.hotelDetailsOpened = false;
  }

  @HostListener('window:popstate')
  onPopState(): void {
    if (this.hotelDetailsOpened) {
      this.dialogOpenedViaHistory = false;
      this.staleDialogEntry = false;
      this.hotelDetailsOpened = false;
    } else if (this.moreRatesPopupContent != null) {
      this.dialogOpenedViaHistory = false;
      this.staleDialogEntry = false;
      this.moreRatesPopupContent = null;
    } else if (this.readmoreContent != null) {
      this.dialogOpenedViaHistory = false;
      this.staleDialogEntry = false;
      this.readmoreContent = null;
    } else if (this.staleDialogEntry) {
      // Dummy entry remains after dialog was closed via UI. Continue navigating back
      // to the real previous page. At this point the URL is already /availability,
      // so history.go(-1) goes to a different URL — Angular handles it as a real
      // navigation, not a same-URL reload.
      this.staleDialogEntry = false;
      history.go(-1);
    }
  }

  private pushDialogHistory(): void {
    history.pushState(null, '', window.location.href);
    this.dialogOpenedViaHistory = true;
  }

  private cleanupDialogHistory(): void {
    if (this.dialogOpenedViaHistory) {
      this.dialogOpenedViaHistory = false;
      this.staleDialogEntry = true;
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  getRoomCategory(roomObject:any) {
    if (this.settings.get('searchMask.usePmsCategories')) {
      return roomObject.roomCategory;
    }
    else {
      return roomObject.beRoomCategoryCode;
    }
  }

  loadExternalLoginData() {
    let loginSession = this.storage.loadSessionStorage('extLogin');
    if (loginSession) {
      let sessionObj:IExternalLoginData = JSON.parse(atob(loginSession));
      if (sessionObj.email && sessionObj.membershipNumber && sessionObj.loginProvider == this.settings.get('externalLoginProvider')) {
        this.externalLoginData = sessionObj;
      }
    }
  }
}
